<dx-box
    #communityBox
    height="100%"
    width="100%"
    direction="col"
    class="cc-search-grid-container"
    [elementAttr]="{ id: 'communityBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1" [visible]="hasRecords">
        <div *dxTemplate class="grid-container">
            <cc-data-grid-features
                #gridFeatures
                [stateConfig]="{ storageKey: 'COMMUNITY_SEARCH_GRID' }"
                [dataSource]="communityList"
            >
                <dx-data-grid width="100%" height="100%" [dataSource]="communityList">
                    <dxo-search-panel [text]="searchText"></dxo-search-panel>
                    <dxi-column
                        dataField="communityName"
                        dataType="string"
                        cellTemplate="communityTemplate"
                        caption="Community"
                    ></dxi-column>
                    <dxi-column dataField="locationName" dataType="string" caption="Location"></dxi-column>
                    <dxi-column
                        dataField="managementCompanyName"
                        dataType="string"
                        caption="Management Company"
                    ></dxi-column>
                    <dxi-column
                        dataField="status"
                        dataType="string"
                        caption="Status"
                        alignment="center"
                        cellTemplate="statusCellTempalte"
                        [visible]="false"
                    ></dxi-column>
                    <dxi-column dataField="legalName" dataType="string" caption="Legal Name"></dxi-column>
                    <dxi-column dataField="intacctCompanyId" dataType="string" caption="Community Code"></dxi-column>

                    <div *dxTemplate="let cell of 'communityTemplate'">
                        <app-property-community-link
                            [communityId]="cell.data.communityId"
                            [displayText]="cell.value"
                            (onClick)="onCommunityClick(cell.data)"
                        ></app-property-community-link>
                    </div>
                    <div *dxTemplate="let row of 'statusCellTempalte'" class="status-cell-template">
                        <i
                            *ngIf="row.value === 'InProduction'"
                            class="cc-community-production cc-1-5x"
                            [ngClass]="iconProduction"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'In Production')"
                        ></i>
                        <i
                            *ngIf="row.value === 'InTransition'"
                            class="cc-community-intransition cc-1-25x"
                            [ngClass]="iconTransition"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'In Transition')"
                        ></i>
                        <i
                            *ngIf="row.value === 'Terminated'"
                            class="cc-community-terminated cc-1-25x"
                            [ngClass]="iconTerminate"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'Terminated')"
                        ></i>
                        <i
                            *ngIf="!!row.data.terminatingDate && row.value !== 'Terminated'"
                            class="cc-community-terminating cc-1-25x"
                            [ngClass]="iconExclamatory"
                            aria-hidden="true"
                            [title]="getStatus(row.data, 'Terminating')"
                        ></i>
                    </div>

                    <dxo-summary>
                        <dxi-group-item
                            column="communityId"
                            summaryType="count"
                            displayFormat="Count = {0}"
                        ></dxi-group-item>
                    </dxo-summary>
                </dx-data-grid>
            </cc-data-grid-features>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1" [visible]="!hasRecords">
        <div *dxTemplate class="grid-container">
            {{ noRecordMessage }}
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#communityBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
